import React from "react";
import {Navigate, useNavigate} from "react-router-dom";
import {useAppSelector} from "./hooks/useStore";
import {selectIsStaff} from "./store/slices/userSlice";

const Home = () => {
    const navigate = useNavigate();
    const userIsStaff = useAppSelector(selectIsStaff);
    const profiles = useAppSelector(state => state.user.profiles);
    const activeMembership = useAppSelector(state => state.user.membership);

    React.useEffect(() => {
        if (profiles?.length > 1 && !userIsStaff) {
            // Redirect to Change Profile page if member has multiple profiles.
            navigate('/profile_change');
        } else if (!activeMembership && !userIsStaff){
            // If it is a single profile login, with an inactive membership redirect to personal info page.
            navigate('/profile/personal_info');
        }
    }, [activeMembership, navigate, profiles, userIsStaff]);

    return <Navigate to="/booking/list"/>;
};

export default Home;
